// Components
import { Box, Text } from 'yard-utilities/components'
import HeaderElement from './elements/HeaderElement'
import FooterElement from './elements/FooterElement'

// Interfaces
import { FooterElementProps } from './elements/FooterElement'
import { HeaderElementProps } from './elements/HeaderElement'

interface FacebookReviewCardProps
  extends HeaderElementProps,
    FooterElementProps {
  children: string | React.ReactNode
}

const FacebookReviewCard = ({
  children,
  comments,
  likes,
  avatar,
  name,
  reviewPosted
}: FacebookReviewCardProps) => {
  return (
    <Box
      borderRadius={{ sm: [10] }}
      padding={{ sm: [12, 16] }}
      backgroundColor="white"
      shadow="shadow-75"
    >
      <HeaderElement avatar={avatar} name={name} reviewPosted={reviewPosted} />
      <Text
        tagName="p"
        variant="body-3"
        textColor="black-soft"
        fontFamily="arial"
        style={{ lineHeight: '2rem' }}
      >
        {children}
      </Text>
      <FooterElement comments={comments} likes={likes} />
    </Box>
  )
}

export default FacebookReviewCard
